import React from 'react';
import {Flex, Button} from 'components';
import {Announcement} from './announcement';
import {config} from 'helpers';

export class Update_2024_01_01_UatTesting extends Announcement {
  eligible() {
    return config.uat;
  }

  render() {
    return (
      <div>
        <h1>UAT Mode</h1>
        <p>You are using a development build.</p>
        <Flex className={['spacing', 'right']}>
          <Button href="/" className="subtle">
            Use prod
          </Button>
          <Button onClick={this.props.next} className={['primary', 'filled']}>
            Proceed
          </Button>
        </Flex>
      </div>
    );
  }
};
